import { z } from 'zod';
const kind = z.enum(['company', 'contact']);
export const consolidationDescriptionSchema = z.object({
    mode: z.enum(['combine', 'reword']),
    text: z.string().trim().min(1).max(2000),
    sourceIds: z.array(z.string().uuid()).min(2).max(20),
});
export const consolidateSchema = z.object({
    kind,
    canonicalId: z.string().uuid(),
    sourceId: z.string().uuid(),
    key: z.string().uuid(),
    reason: z.string().trim().min(1).max(2000),
    confirmSameIdentity: z.literal(true),
    choices: z.record(z.string(), z.string().uuid()).default({}),
    descriptions: z.record(z.string(), consolidationDescriptionSchema).default({}),
});
export const canonicalRecordSchema = z.object({ kind, id: z.string().uuid() });
export const reverseConsolidationSchema = z.object({
    eventId: z.string().uuid(),
    reason: z.string().trim().min(1).max(2000),
});
//# sourceMappingURL=consolidation.js.map